// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-page-wrapper {
    min-height: calc(100vh - 70px);
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 20px 40px;
    background-color: var(--bg-app);
}

.edit-card {
    width: 100%;
    max-width: 500px;
    background-color: var(--bg-card);
    padding: 40px;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-light);
    animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

.form-header {
    text-align: center;
    margin-bottom: 24px;
}

.form-header h1 {
    font-size: 1.5rem;
    font-weight: 800;
    color: var(--brand-primary);
    margin: 0 0 8px 0;
}

.form-header p {
    color: var(--text-muted);
    font-size: 0.9rem;
    margin: 0;
}

.edit-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.form-group label {
    display: block;
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--text-main);
    margin-bottom: 6px;
}

.form-control {
    width: 100%;
    height: 50px;
    padding: 0 16px;
    background-color: var(--bg-input);
    border: 1px solid var(--border-light);
    border-radius: var(--radius-input);
    font-size: 1rem;
    color: var(--text-main);
    transition: var(--transition);
    box-sizing: border-box;
    font-family: inherit;
}

.form-control:focus {
    outline: none;
    background-color: #fff;
    border-color: var(--brand-primary);
    box-shadow: var(--shadow-input-focus);
}

textarea.form-control {
    height: auto;
    min-height: 100px;
    padding: 12px 16px;
    resize: vertical;
}

.form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 10px;
}

.btn-cancel {
    background: transparent;
    border: none;
    color: var(--text-muted);
    font-weight: 600;
    cursor: pointer;
    padding: 10px 20px;
    border-radius: var(--radius-input);
    transition: background 0.2s;
}

.btn-cancel:hover {
    background-color: var(--bg-input);
    color: var(--text-main);
}

.btn-submit {
    background-color: var(--brand-primary);
    color: #fff;
    border: none;
    padding: 12px 24px;
    border-radius: var(--radius-input);
    font-weight: 700;
    cursor: pointer;
    transition: var(--transition);
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.btn-submit:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0,0,0,0.15);
}

.btn-submit:disabled {
    background-color: #CBD5E1;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.loading-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    color: var(--text-muted);
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(0,0,0,0.1);
    border-top-color: var(--brand-accent);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
}

@keyframes spin { to { transform: rotate(360deg); } }

.error-banner {
    background-color: #FEF2F2;
    border: 1px solid #FECACA;
    color: var(--error);
    padding: 12px;
    border-radius: var(--radius-md);
    margin-bottom: 20px;
    text-align: center;
    font-size: 0.9rem;
}

@media (max-width: 480px) {
    .form-actions {
        flex-direction: column-reverse;
    }
    .btn-cancel, .btn-submit {
        width: 100%;
        text-align: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/EditAmericana.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,8BAA8B;IAC9B,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE5D;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,kCAAkC;IAClC,eAAe;IACf,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ","sourcesContent":[".edit-page-wrapper {\n    min-height: calc(100vh - 70px);\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 30px 20px 40px;\n    background-color: var(--bg-app);\n}\n\n.edit-card {\n    width: 100%;\n    max-width: 500px;\n    background-color: var(--bg-card);\n    padding: 40px;\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-light);\n    animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n\n.form-header {\n    text-align: center;\n    margin-bottom: 24px;\n}\n\n.form-header h1 {\n    font-size: 1.5rem;\n    font-weight: 800;\n    color: var(--brand-primary);\n    margin: 0 0 8px 0;\n}\n\n.form-header p {\n    color: var(--text-muted);\n    font-size: 0.9rem;\n    margin: 0;\n}\n\n.edit-form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.form-group label {\n    display: block;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: var(--text-main);\n    margin-bottom: 6px;\n}\n\n.form-control {\n    width: 100%;\n    height: 50px;\n    padding: 0 16px;\n    background-color: var(--bg-input);\n    border: 1px solid var(--border-light);\n    border-radius: var(--radius-input);\n    font-size: 1rem;\n    color: var(--text-main);\n    transition: var(--transition);\n    box-sizing: border-box;\n    font-family: inherit;\n}\n\n.form-control:focus {\n    outline: none;\n    background-color: #fff;\n    border-color: var(--brand-primary);\n    box-shadow: var(--shadow-input-focus);\n}\n\ntextarea.form-control {\n    height: auto;\n    min-height: 100px;\n    padding: 12px 16px;\n    resize: vertical;\n}\n\n.form-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 10px;\n}\n\n.btn-cancel {\n    background: transparent;\n    border: none;\n    color: var(--text-muted);\n    font-weight: 600;\n    cursor: pointer;\n    padding: 10px 20px;\n    border-radius: var(--radius-input);\n    transition: background 0.2s;\n}\n\n.btn-cancel:hover {\n    background-color: var(--bg-input);\n    color: var(--text-main);\n}\n\n.btn-submit {\n    background-color: var(--brand-primary);\n    color: #fff;\n    border: none;\n    padding: 12px 24px;\n    border-radius: var(--radius-input);\n    font-weight: 700;\n    cursor: pointer;\n    transition: var(--transition);\n    box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n}\n\n.btn-submit:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 14px rgba(0,0,0,0.15);\n}\n\n.btn-submit:disabled {\n    background-color: #CBD5E1;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.loading-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 50vh;\n    color: var(--text-muted);\n}\n\n.spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid rgba(0,0,0,0.1);\n    border-top-color: var(--brand-accent);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-bottom: 16px;\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.error-banner {\n    background-color: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: var(--error);\n    padding: 12px;\n    border-radius: var(--radius-md);\n    margin-bottom: 20px;\n    text-align: center;\n    font-size: 0.9rem;\n}\n\n@media (max-width: 480px) {\n    .form-actions {\n        flex-direction: column-reverse;\n    }\n    .btn-cancel, .btn-submit {\n        width: 100%;\n        text-align: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
